// extracted by mini-css-extract-plugin
export default {"first":"#0a4d28","productTextBody":"Deska_tarasowa_productTextBody__hPTTs","green":"Deska_tarasowa_green__3YzE4"};